export default __webpack_public_path__ + "static/Quickswap-bw-19-e109267961f8f7f267000a6f38496117.svg";